import { CheckCircleOutlined } from '@ant-design/icons'
import { notification } from 'antd'
import React from 'react'
import { theme } from 'src/branding/omsTheme'
import { getSupplierCreateSuccessMessage } from 'src/utils/supplierCreateBrandTag'

export const SUPPLIER_CREATE_VENUES_PATH = '/venues'

export const getSupplierProductsPath = supplierId =>
  supplierId ? `/admin/products?supplierId=${supplierId}` : '/admin/products'

const NotificationLink = ({ history, to, children }) => (
  <a
    href={to}
    onClick={event => {
      event.preventDefault()
      history.push(to)
    }}
  >
    {children}
  </a>
)

export const SupplierCreateNextSteps = ({ supplier, history }) => (
  <div>
    <p style={{ marginBottom: 8 }}>What&apos;s next:</p>
    <ul style={{ margin: 0, paddingLeft: 20 }}>
      <li>
        <NotificationLink
          history={history}
          to={getSupplierProductsPath(supplier?._id)}
        >
          Add products
        </NotificationLink>{' '}
        for this supplier
      </li>
      <li>
        <NotificationLink history={history} to={SUPPLIER_CREATE_VENUES_PATH}>
          Enable at venues
        </NotificationLink>{' '}
        — open a venue and turn the supplier on in Your Suppliers
      </li>
    </ul>
  </div>
)

export const showSupplierCreateSuccessNotification = (supplier, history) => {
  notification.open({
    message: getSupplierCreateSuccessMessage(supplier),
    description: (
      <SupplierCreateNextSteps supplier={supplier} history={history} />
    ),
    duration: 10,
    icon: <CheckCircleOutlined style={{ color: theme.colours.lettuceGreen }} />,
  })
}
